"use client";

import { reportGAEvent } from "~/lib/GoogleAds";
/**
 * Parent abstraction for tracked UI elements: wraps any clickable component so
 * it reports a Google Ads event on click. Derive a tracked variant with
 * `withTracking(SomeComponent)` instead of re-wiring the reporting per element.
 * The wrapped component's own `onClick` is preserved and fires after the report.
 */
export function withTracking(Component) {
  return function Tracked(props) {
    // Widen locally so `onClick` is destructurable and typed as a plain handler,
    // regardless of the wrapped component's element-specific event type.
    const {
      ctaName,
      eventCategory,
      onClick,
      ...rest
    } = props;
    const Comp = Component;
    return <Comp {...rest} onClick={event => {
      reportGAEvent(ctaName, eventCategory);
      onClick?.(event);
    }} />;
  };
}